@if (open) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4 py-8"
    (click)="close.emit()"
  >
    <div
      class="w-full max-w-3xl max-h-[90vh] rounded-[28px] bg-white shadow-2xl overflow-y-auto"
      (click)="$event.stopPropagation()"
      role="dialog"
      aria-modal="true"
    >
      <div class="p-6 sm:p-8 relative">
        <button
          type="button"
          class="close-btn"
          (click)="close.emit()"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
  
        
        @if (isLoadingProfile) {
          <div class="size-full pt-8 flex items-center justify-center">
            <div class="flex flex-col items-center gap-3">
              <div
              class="size-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
              ></div>
              <p class="text-sm font-medium text-slate-500 text-center">
                Fetching user information...
              </p>
            </div>
          </div>
        } @else {
          <div class="header-card">
            <div class="avatar" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                class="h-8 w-8"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"></path>
                <circle cx="9.5" cy="7" r="3"></circle>
                <path d="M20 8v6"></path>
                <path d="M23 11h-6"></path>
              </svg>
            </div>
    
            <div class="min-w-0">
              <app-page-header
                [title]="profile?.name || 'N/A'"
                [subtitle]="profile?.email || 'N/A'"
              ></app-page-header>
              <div class="role-pill">{{ profile?.roleLabel || 'N/A' }}</div>
            </div>
          </div>

          <div class="kv-grid">
            <!-- <div class="kv">
              <span class="kv__key">MDA</span>
              <span class="kv__value">{{ profile.mda || "N/A" }}</span>
            </div> -->
            <div class="kv">
              <span class="kv__key">Phone Number</span>
              <span class="kv__value">{{ profile?.phoneNumber || "N/A" }}</span>
            </div>
            <div class="kv">
              <span class="kv__key">Date Registered</span>
              <span class="kv__value">{{ (profile?.dateRegistered | date:'dd/MM/yyyy') || "N/A" }}</span>
            </div>
          </div>

          @if (profile) {
            <div class="status-card">
              <div class="status-icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  class="h-8 w-8"
                >
                  <circle cx="12" cy="12" r="9"></circle>
                  <path d="m8.5 12 2.2 2.2 4.8-5"></path>
                </svg>
              </div>
              <div class="min-w-0">
                <div class="status-title">{{ profile?.accountStatusTitle || "N/A" }}</div>
                <div class="status-subtitle">{{ profile?.accountStatusSubtitle || "N/A" }}</div>
                <!-- <div class="status-last-login">
                  Last login: {{ profile.lastLoginText }}
                </div> -->
              </div>
      
            </div>
          }
    
        }
  
  
        <section class="security-card" aria-labelledby="totp-security-title">
          <div class="security-card__header">
            <div class="security-icon" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.9"
              >
                <path
                  d="M12 3 5 6v5c0 4.4 2.9 8.4 7 9.7 4.1-1.3 7-5.3 7-9.7V6l-7-3Z"
                ></path>
                <path d="m9 12 2 2 4-4"></path>
              </svg>
            </div>
  
            <div class="security-copy">
              <h3 id="totp-security-title">Two-factor authentication</h3>
              <p>
                {{
                  isTOTPEnabled
                    ? "Authenticator app protection is active."
                    : "Protect sign in with an authenticator app."
                }}
              </p>
            </div>
  
            <label class="security-switch">
              <input
                type="checkbox"
                [checked]="isTOTPEnabled || isTOTPSetupPending"
                [disabled]="isTOTPBusy"
                (change)="onTOTPToggle($event)"
                aria-label="Toggle two-factor authentication"
              />
              <span></span>
            </label>
          </div>
  
          <div
            class="security-state"
            [class.security-state--enabled]="isTOTPEnabled"
            [class.security-state--pending]="isTOTPSetupPending"
          >
            <span class="security-state__dot"></span>
            <span>
              {{
                isTOTPEnabled
                  ? "Enabled"
                  : isTOTPSetupPending
                    ? "Setup pending"
                    : "Disabled"
              }}
            </span>
          </div>
  
          <div *ngIf="isStartingTOTP" class="security-loading">
            Preparing authenticator setup...
          </div>
  
          <div *ngIf="setupData" class="totp-setup-panel">
            <div class="totp-qr-wrap">
              <div class="totp-qr-badge">Step 1</div>
              <div class="totp-qr-frame">
                <img
                  [src]="setupQRCodeSrc"
                  alt="Authenticator setup QR code"
                  class="totp-qr"
                />
              </div>
              <div class="totp-qr-caption">
                Open Google Authenticator and scan this code.
              </div>
            </div>
  
            <div class="totp-setup-panel__body">
              <h4>Scan QR code</h4>
              <p>
                Use Google Authenticator, then enter the generated 6-digit code.
              </p>
  
              <div class="manual-key">
                <span>{{ setupData.manual_entry_key }}</span>
                <button type="button" (click)="copyManualEntryKey()">Copy</button>
              </div>
  
              <label class="totp-code-field">
                <span>Authenticator code</span>
                <input
                  type="text"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  maxlength="6"
                  [ngModel]="setupCode"
                  (ngModelChange)="setupCode = normalizeCode($event)"
                  [disabled]="isConfirmingTOTP"
                  placeholder="000000"
                />
              </label>
  
              <div class="security-actions">
                <button
                  type="button"
                  class="security-btn security-btn--primary"
                  [disabled]="!setupCodeReady || isConfirmingTOTP"
                  (click)="confirmTOTPSetup()"
                >
                  {{ isConfirmingTOTP ? "Verifying..." : "Verify and enable" }}
                </button>
                <button
                  type="button"
                  class="security-btn security-btn--ghost"
                  [disabled]="isConfirmingTOTP"
                  (click)="cancelTOTPSetup()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
  
          <div *ngIf="showDisableCode" class="totp-disable-panel">
            <div>
              <h4>Disable two-factor authentication</h4>
              <p>
                Enter your current authenticator code to turn off this protection.
              </p>
            </div>
  
            <label class="totp-code-field">
              <span>Authenticator code</span>
              <input
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="6"
                [ngModel]="disableCode"
                (ngModelChange)="disableCode = normalizeCode($event)"
                [disabled]="isDisablingTOTP"
                placeholder="000000"
              />
            </label>
  
            <div class="security-actions">
              <button
                type="button"
                class="security-btn security-btn--danger"
                [disabled]="!disableCodeReady || isDisablingTOTP"
                (click)="confirmTOTPDisable()"
              >
                {{ isDisablingTOTP ? "Disabling..." : "Disable 2FA" }}
              </button>
              <button
                type="button"
                class="security-btn security-btn--ghost"
                [disabled]="isDisablingTOTP"
                (click)="cancelTOTPDisable()"
              >
                Cancel
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
}

